import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertifyService } from '../core/alertify.service';
import { ModalUtilsService } from '../core/modal-utils.service';
import { SessionStorageService } from '../session-storage.service';
import { StringUtils } from '../../utils/string.utils';


@Injectable({
  providedIn: 'root'
})
export class PrinterUtilsService {

  constructor(private sessionStorageService: SessionStorageService,
    private alertifyService: AlertifyService,
    private translate: TranslateService,
    private modalUtilsService: ModalUtilsService) { }

  async getPrinterName(key: string): Promise<string> {
    let printerName = this.sessionStorageService.getString(key);

    if (StringUtils.isEmpty(printerName)) {
      this.alertifyService.warning(this.translate.instant('message.error.the-printer-is-not-defined-define-the-printer-from-the-printers-menu'));

      //yazıcıların güncellenmesi sağlansın
      await this.modalUtilsService.openPrinterSettingModal();

      printerName = this.sessionStorageService.getString(key);

      if (StringUtils.isEmpty(printerName))
        throw Error(this.translate.instant('message.error.the-printer-is-not-defined-define-the-printer-from-the-printers-menu'));
    }
    return printerName!;
  }
}
